import core from './core';

const CookieCheck = core.extend({
	constructor() {
		if (this.isCookieDisabled()) {
			this.showMessage();
		}
	},

	isCookieDisabled() {
		return !navigator.cookieEnabled;
	},

	showMessage() {
		jQuery('.cookie-message').removeClass('hide');
	},

	setCookie(cookieName, daysToLive) {
		const date = new Date();

		date.setTime(date.getTime() + daysToLive * 24 * 60 * 60 * 1000);
		document.cookie = `${cookieName}=true; expires=${date.toUTCString()}`;
	},

	checkIfCookieSet(keyToMatch) {
		const cookieAsArray = document.cookie.split(';');

		for (let i = 0; i < cookieAsArray.length; i++) {
			const key = cookieAsArray[i].trim().split('=')[0];

			if (key === keyToMatch) {
				return true;
			}
		}

		return false;
	},
});

export default CookieCheck;
